import { graphql, useStaticQuery } from 'gatsby'
import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import Prism from 'prismjs'
import ChevronDown from './ChevronDown'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-java'
import 'prismjs/components/prism-ruby'
import 'prismjs/components/prism-c'
import 'prismjs/components/prism-csharp'
import 'prismjs/components/prism-objectivec'
import 'prismjs/components/prism-swift'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-go'
import 'prismjs/components/prism-lua'
import 'prismjs/components/prism-haskell'
import 'prismjs/components/prism-erlang'
import 'prismjs/components/prism-dart'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/themes/prism-tomorrow.css'

import '../styles/code.scss'
import '../styles/implementation.scss'

const SdkSetupInstructionsComponent = (props) => {
  const { data, images } = props

  const selectImage = (name) => images.find((n) => n.name.toLowerCase() === name.toLowerCase()).publicURL

  const [sdkSelectedName, setSdkSelectedName] = useState(data[6].Name)
  const [sdkSelectedImage, setSdkSelectedImage] = useState(selectImage(data[6].Logo))
  const [sdkDropdownOpen, setSdkDropdownOpen] = useState(false)

  const handleTileClick = (name, image) => {
    setSdkSelectedName(name)
    setSdkSelectedImage(image)
    setSdkDropdownOpen(false)
  }

  const handleDropdownClick = () => {
    setSdkDropdownOpen(!sdkDropdownOpen)
  }

  useEffect(() => {
    Prism.highlightAll()
  }, [])

  return (
    <>
      <div className="sdk-dropdown">
        <div className="dropdown-select-button" onClick={handleDropdownClick}>
          <div className="sdk-info">
            <img src={sdkSelectedImage} alt={sdkSelectedName} />
            <p className="sdk-name dark-font">{sdkSelectedName}</p>
          </div>
          <span
            className={classNames('sdk-down-arrow', {
              'sdk-down-arrow-rotate': sdkDropdownOpen
            })}
          >
            <ChevronDown />
          </span>
        </div>
        <ul
          className={classNames('sdk-dropdown-full', {
            'sdk-dropdown-display': sdkDropdownOpen
          })}
        >
          {data.map((sdk, i) => {
            const sdkName = sdk.Name
            const image = selectImage(sdk.Logo)
            return (
              <li
                className="sdk-tile"
                key={i}
                onClick={() => {
                  handleTileClick(sdkName, image)
                }}
              >
                <img src={image} alt={sdkName} className="sdk-image" />
                <p className="sdk-name">{sdkName}</p>
              </li>
            )
          })}
        </ul>
      </div>
      <div>
        {data.map((sdk, i) => (
          <div
            className={classNames('tabContent', {
              'tabContent--selected': sdk.Name === sdkSelectedName
            })}
            key={i}
          >
            {sdk.SetupSteps.map((setup) => (
              <>
                <p>{setup.Text}</p>
                {setup.Code && (
                  <div className="code-example">
                    <pre>
                      <code className={`language-${sdk.Lexer}`} style={{ fontFamily: 'monospace' }}>
                        {setup.Code}
                      </code>
                    </pre>
                  </div>
                )}
              </>
            ))}
            {sdk.FullDocsUrl && (
              <a href={sdk.FullDocsUrl} target="_blank" rel="noopener noreferrer">
                View full documentation here
              </a>
            )}
          </div>
        ))}
      </div>
    </>
  )
}

const SdkSetupInstructions = () => {
  const query = graphql`
    query sdkSetupInstructionsQuery {
      allFile(filter: { relativeDirectory: { eq: "sdks" } }) {
        nodes {
          publicURL
          name
        }
      }
      allSdkJson {
        nodes {
          Name
          id
          Lexer
          Logo
          FullDocsUrl
          SetupSteps {
            Text
            Code
            Lexer
          }
        }
      }
    }
  `
  const data = useStaticQuery(query)

  return <SdkSetupInstructionsComponent data={data.allSdkJson.nodes} images={data.allFile.nodes} />
}

export default SdkSetupInstructions
